module.exports = __webpack_public_path__ + "img/050-scarecrow.2de2687f.png";